/**
 * 空间关系运算工具类
 * Created by 1 on 2016/12/29.
 */
'use strict';
define([
	'./GeometryUtil',
	'./CommonUtil',
	'../g2'
], function(
	GeometryUtil,
	CommonUtil,
	g2
) {
	/**
	 * @namespace
	 * @description 空间关系运算工具类，包括缓冲，求交、求并等
	 * @alias G.utils.SpatialOPUtil
	 */
	var util = {};

	util._getJstsGeometry = GeometryUtil._getJstsGeometry;

	util._fromJstsGeometry = GeometryUtil._fromJstsGeometry;

	/**
	 * 合并多个几何对象
	 * @method
	 * @param geometryArr {Array} 必填，可以传递g2.sfs.Geometry对象、wkt字符串、geojson对象数组；
	 * @returns 返回对象与传入的类型一致；
	 */
	util.unionGeometry = function(geometryArr) {
		return GeometryUtil._unionGeometry(geometryArr);
	}

	/**
	 * 返回从geom中挖取digArr数组中的部分；
	 * @method
	 * @param geom {Object} 必填 GeoJSONObject/String/g2.sfs.Geometry操作的几何对象
	 * @param digArr {Array} 必填,几何对象数组；
	 * @returns {Object} -GeoJSONObject/String/g2.sfs.Geometry
	 */
	util.differGeom = function(geom, digArr) {
		if(!geom || !digArr) {
			return null;
		}
		var jstsGeom, resultGeom = null,
			type, i = 0,
			len = digArr.length;
		var unit = 360 / (2 * Math.PI * 6378137);
		var object = this._getJstsGeometry(geom);
		if(object) {
			jstsGeom = object.geometry;
			jstsGeom = jsts.simplify.DouglasPeuckerSimplifier.simplify(jstsGeom, unit);
			type = object.type;
			for(; i < len; i++) {
				var object1 = this._getJstsGeometry(digArr[i]);
				if(object1) {
					var geom = object1.geometry;
					if(geom && jstsGeom) {
						geom = jsts.simplify.DouglasPeuckerSimplifier.simplify(geom, unit);
						if(jstsGeom.within(geom)) {
							jstsGeom = null;
						} else if(jstsGeom.intersects(geom)) {
							jstsGeom = jstsGeom.difference(geom);
						}
					}
				}
			}
		}
		if(jstsGeom) {
			switch(type) {
				case 1:
					{
						resultGeom = g2.sfs.GeometryFormatter.fromWKT(jstsGeom.toString());
						break;
					}
				case 2:
					{
						resultGeom = jstsGeom.toString();
						break;
					}
				case 3:
					{
						if(jstsGeom.CLASS_NAME == 'jsts.geom.GeometryCollection') {
							if(jstsGeom.geometries.length == 0) {
								jstsGeom = null;
							}
						}
						if(jstsGeom) {
							resultGeom = g2.sfs.GeometryFormatter.fromWKT(jstsGeom.toString());
							resultGeom = resultGeom.asGeoJson();
						}
						break;
					}
				default:
					{
						break;
					}
			}
		}
		return resultGeom;
	},
	/**
	 * 返回从geom中与digArr数组中相交的部分；
	 * @method
	 * @param geom {Object} 必填 GeoJSONObject/String/g2.sfs.Geometry操作的几何对象
	 * @param digArr {Array} 必填,几何对象数组；
	 * @returns {Object} -GeoJSONObject/String/g2.sfs.Geometry
	 */
	util.interGeom = function(geom, digArr) {
		if(!geom || !digArr) {
			return null;
		}
		var jstsGeom, resultGeom = null,
			type, i = 0,
			len = digArr.length;
		var unit = 360 / (2 * Math.PI * 6378137);
		var object = this._getJstsGeometry(geom);
		if(object) {
			jstsGeom = object.geometry;
			jstsGeom = jsts.simplify.DouglasPeuckerSimplifier.simplify(jstsGeom, unit);
			type = object.type;
			for(; i < len; i++) {
				var object1 = this._getJstsGeometry(digArr[i]);
				if(object1) {
					var geom = object1.geometry;
					if(geom && jstsGeom) {
						geom = jsts.simplify.DouglasPeuckerSimplifier.simplify(geom, unit);
						if(jstsGeom.within(geom)) {
							jstsGeom = geom;
						} else if(jstsGeom.intersects(geom)) {
							jstsGeom = jstsGeom.intersection(geom);
						}
					}
				}
			}
		}
		if(jstsGeom) {
			switch(type) {
				case 1:
				{
					resultGeom = g2.sfs.GeometryFormatter.fromWKT(jstsGeom.toString());
					break;
				}
				case 2:
				{
					resultGeom = jstsGeom.toString();
					break;
				}
				case 3:
				{
					if(jstsGeom.CLASS_NAME == 'jsts.geom.GeometryCollection') {
						if(jstsGeom.geometries.length == 0) {
							jstsGeom = null;
						}
					}
					if(jstsGeom) {
						resultGeom = g2.sfs.GeometryFormatter.fromWKT(jstsGeom.toString());
						resultGeom = resultGeom.asGeoJson();
					}
					break;
				}
				default:
				{
					break;
				}
			}
		}
		return resultGeom;
	}

	/**
	 * 获取缓冲区
	 * @method
	 * @param options {Object} 必填，参数
	 * @param options.geometry {Object} 必填，缓冲的几何g2.sfs.Geometry or Wkt or GeoJSON
	 * @param options.radius {Number} 必填，缓冲半径，单位/米
	 * @param options.spatialReference {Number} 必填，坐标系
	 * @returns {Object} -jsts.geom.Geometry
	 */
	util.getBuffer = function(options) {
		options.spatialReference = options.spatialReference || g2.sfs.EnumSpatialReference.EPSG4326;
		//wkt解析器
		var reader = GeometryUtil.getWktReader();
		//
		var object = this._getJstsGeometry(options.geometry) || {};
		if(!object || !object.geometry) {
			return null;
		}
		var radius = options.radius,
			isGeographySr = (options.spatialReference == g2.sfs.EnumSpatialReference.EPSG4326 ||
				options.spatialReference == g2.sfs.EnumSpatialReference.EPSG4490) || false;
		var geometry = object.geometry,
			buffer = null;
		if(geometry instanceof jsts.geom.Point) {
			//经纬度坐标是椭圆
			if(isGeographySr) {
				var points = GeometryUtil.getCirclePonits({
					center: [geometry.getX(), geometry.getY()],
					radius: radius,
					count: 128,
					spatialReference: options.spatialReference
				});
				points.push([points[0][0], points[0][1]]);
				var json = {
					type: "Polygon",
					coordinates: [points]
				}
				buffer = GeometryUtil.getGeoJSONReader().read(json);
			} else {
				buffer = geometry.buffer(radius);
				// buffer=G.utils.GeometryUtil.simplify(buffer);
			}
		} else if(geometry instanceof jsts.geom.Geometry) {
			if(isGeographySr) {
				radius = GeometryUtil.meter2Rad(radius);
			}
			buffer = geometry.buffer(radius);
			// buffer=G.utils.GeometryUtil.simplify(buffer);
		}
		var bufferGeom = this._fromJstsGeometry({
			geometry: buffer,
			type: object.type,
			spatialReference: options.spatialReference
		});
		return bufferGeom;
	}

	/**
	 * 计算两点间距离
	 * @method
	 * @param point1 {Array} 必填-[x,y] 第一个点坐标数组
	 * @param point2 {Array} 必填-[x,y] 第二个点坐标数组
	 * @param spatialReference {Number} 坐标系，默认为4326
	 * @returns {Number} 两点间距离数值
	 */
	util.caculateDisatance = function(point1, point2, spatialReference) {
		if(!(CommonUtil.isArray(point1) &&
				CommonUtil.isArray(point2))) {
			throw(new Error('参数类型错误！'));
		}
		spatialReference = isNaN(spatialReference) ? 4326 : spatialReference;
		var pt1 = new g2.sfs.Point({
			x: point1[0],
			y: point1[1]
		});
		var pt2 = new g2.sfs.Point({
			x: point2[0],
			y: point2[1]
		});
		var polyline = new g2.sfs.Polyline({ spatialReference: spatialReference });
		var path = new g2.sfs.Path({ spatialReference: spatialReference });
		path.addPoint(pt1);
		path.addPoint(pt2);
		polyline.addGeometry(path);
		var projectService = new g2.sfs.CoordinateTransform();
		var measureService = new g2.sfs.MeasureService({ projectService: projectService });
		var length = measureService.length(polyline);
		return length;
	};
	/**
	 * 获取点到线段的距离
	 * @method
	 * @param x {Number} 必填，点x
	 * @param y {Number}必填，点y
	 * @param x1{Number}必填，线段起点x
	 * @param y1{Number}必填，线段起点y
	 * @param x2{Number}必填，线段终点x
	 * @param y2{Number}必填，线段终点y
	 * @return {Object} -{	distance:距离；	nearest:最近的点； }
	 */
	util.point2SegmentDistance = function(x, y, x1, y1, x2, y2) {
		var data = {};
		var cross = (x2 - x1) * (x - x1) + (y2 - y1) * (y - y1);
		/***
		 * 最近点在起点
		 * */
		if(cross <= 0) {
			data.nearest = [x1, y1];
			data.distance = Math.sqrt((x - x1) * (x - x1) + (y - y1) * (y - y1));
			return data;
		}
		var d2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
		/***
		 * 最近点在终点
		 * */
		if(cross >= d2) {
			data.nearest = [x2, y2];
			data.distance = Math.sqrt((x - x2) * (x - x2) + (y - y2) * (y - y2));
			return data;
		}
		/***
		 * 最近点在线段上
		 * */
		var x0, y0, ya, yb;
		/**
		 * 直线平行于y轴
		 */
		if(x1 == x2) {
			x0 = x1;
			y0 = y;
			data.nearest = [x0, y0];
			data.distance = Math.abs(x - x0);
		}
		/**
		 * 直线平行于x轴
		 */
		else if(y1 == y2) {
			x0 = x;
			y0 = y1;
			data.nearest = [x0, y0];
			data.distance = Math.abs(y - y0);
		} else {
			var K, B, K0, B0;
			K = (y1 - y2) / (x1 - x2);
			B = y1 - K * x1;
			K0 = -1 / K;
			B0 = y - K0 * x;
			x0 = (B0 - B) / (K - K0);
			y0 = K * x0 + B;
			data.nearest = [x0, y0];
			data.distance = Math.sqrt((x - x0) * (x - x0) + (y - y0) * (y - y0));
		}
		return data;
	}

	/**
	 * 在路径按照等距离获取路径上的点
	 * @method
	 * @param options {Object} 必填
	 * @param options.pathGeometry {GeoJSON/g2.sfs.Polyline} 必填，路径点坐标,注：只支持单线
	 * @param options.pathSrid {Number} 可选，路径点的坐标系，默认为3857；
	 * @param options.step {Number} 必填，等距距离 单位 m
	 * @returns {Array} -点数组,[x,y,angle] 返回 x,y,角度(沿顺时针方向与正北方向的夹角)
	 */
	util.getPointAlongPath = function(options) {
		var pathGeometry, pathSrid, pathGeom, step,
			defaultSrid = 3857;
		var projectService = new g2.sfs.CoordinateTransform();
		try {
			pathGeometry = options.pathGeometry;
			pathSrid = options.pathSrid || defaultSrid;
			step = options.step;
			//把坐标系转为3857
			var geometry;
			if(pathGeometry instanceof g2.sfs.Polyline) {
				geometry = pathGeometry;
			} else {
				geometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(pathGeometry);
			}
			geometry.spatialReference = options.pathSrid;
			if(pathSrid != defaultSrid) {
				geometry = projectService.transform(geometry, defaultSrid);
			}
			pathGeom = GeometryUtil.toJstsGeometry(geometry);
		} catch(e) {
			throw(new Error('参数错误！'));
		}

		var points = [],
			pathPoints = pathGeom.points;
		//里程
		var mileage = step,
			pathLen = 0,
			totalLen = pathGeom.getLength();
		var angleFirst = calculationAngle([pathPoints[0].x, pathPoints[0].y], [pathPoints[1].x, pathPoints[1].y]);
		addPoint(points, [pathPoints[0].x, pathPoints[0].y, angleFirst], pathSrid, defaultSrid);
		while(mileage <= totalLen) {
			var point = findPathPoint(pathPoints, mileage, pathSrid);
			addPoint(points, point, pathSrid, defaultSrid);
			mileage += step;
		}
		var angleEnd = calculationAngle([pathPoints[pathPoints.length - 2].x, pathPoints[pathPoints.length - 2].y], [pathPoints[pathPoints.length - 1].x, pathPoints[pathPoints.length - 1].y]);
		addPoint(points, [pathPoints[pathPoints.length - 1].x, pathPoints[pathPoints.length - 1].y, angleEnd], pathSrid, defaultSrid);
		return points;
		/**
		 * 坐标数组转换成3857坐标
		 * @param points {Array} 放置转换后的坐标数组
		 * @param point {Array} 需要转化的坐标数组
		 * @param srcSrid {Number} 需要转化的坐标系
		 * @param destSrid {Number} 当前传入的坐标系
		 * */
		function addPoint(points, point, srcSrid, destSrid) {
			var pointGeom = new g2.sfs.Point({
				x: point[0],
				y: point[1],
				spatialReference: destSrid
			});
			pointGeom = projectService.transform(pointGeom, srcSrid);
			point[0] = pointGeom.x;
			point[1] = pointGeom.y;
			point[2] = point[2];
			points.push(point);
		}
	}
	/**
	 * 根据两点的坐标计算出两点之间的角度
	 * @param pointOne {Array} 第一个点[115 36]
	 * @param pointTwo {Array} 第二个点[115 36]
	 * @return angle {Number} 两点之间的角度
	 * */
	function calculationAngle(pointOne, pointTwo) {
		var px = pointOne[0],
			py = pointOne[1],
			mx = pointTwo[0],
			my = pointTwo[1],
			x = Math.abs(px - mx),
			y = Math.abs(py - my),
			z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)),
			cos = y / z,
			radina = Math.acos(cos), //用反三角函数求弧度
			angle = Math.floor(180 / (Math.PI / radina)); //将弧度转化成角度
		if(mx > px && my > py) {
			angle = 180 - angle;
		}
		if(mx == px && my > py) {
			angle = 180;
		}
		if(mx > px && my == py) {
			angle = 90;
		}
		if(mx < px && my > py) {
			angle = 180 + angle;
		}
		if(mx < px && my == py) {
			angle = 270;
		}
		if(mx < px && my < py) {
			angle = 360 - angle;
		}
		return 180 - angle;
	}
	/**
	 *
	 * @param pathPoints 路径点
	 * @param mileage 行驶里程
	 * @param srid
	 * @returns {Array}
	 */
	function findPathPoint(pathPoints, mileage, srid) {
		var total = 0,
			pt,
			index,
			ptNext,
			distance = 0,
			extra;
		var resultPt = [];
		for(var index = 1; index < pathPoints.length; index++) {
			pt = pathPoints[index - 1];
			ptNext = pathPoints[index];
			distance = caculateDistance(pt.x, pt.y, ptNext.x, ptNext.y, srid);
			total += distance;
			if(total >= mileage) {
				break;
			}
		}
		var angle = calculationAngle([pathPoints[index - 1].x, pathPoints[index - 1].y], [pathPoints[index].x, pathPoints[index].y]);
		extra = mileage - (total - distance);
		var percentage = extra / distance;
		var x = pt.x + (ptNext.x - pt.x) * percentage,
			y = pt.y + (ptNext.y - pt.y) * percentage;
		resultPt = [x, y, angle];
		return resultPt;
	}

	/**
	 * 计算两点距离
	 * @param x1
	 * @param y1
	 * @param x2
	 * @param y2
	 */
	function caculateDistance(x1, y1, x2, y2) {
		return Math.sqrt(Math.pow((x1 - x2), 2) + Math.pow((y1 - y2), 2));
	}

	/**
	 * 获取路径上距离起点指定距离的点
	 * @method
	 * @param options {Object} 必填
	 * @param options.pathGeometry  {GeoJSON/g2.sfs.Polyline} 必填，路径点坐标,注：只支持单线
	 * @param options.pathSrid {Number} 可选，路径点的坐标系，默认为3857；
	 * @param options.distance {Number} 必填，距离 单位 m
	 * @returns {Object} -{ point:[x,y,angle],arrival:false} 返回 x,y,角度(沿顺时针方向与正北方向的夹角)
	 */
	util.getPointOnPath = function(options) {
		var pathGeometry, pathSrid, pathGeom, distance,
			defaultSrid = 3857;
		var projectService = new (g2.sfs.CoordinateTransform);
		try {
			pathGeometry = options.pathGeometry;
			pathSrid = options.pathSrid || defaultSrid;
			distance = options.distance;
			//把坐标系转为3857
			var geometry;
			if(pathGeometry instanceof g2.sfs.Polyline) {
				geometry = pathGeometry;
			} else {
				geometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(pathGeometry);
			}
			geometry.spatialReference = options.pathSrid;
			if(pathSrid != defaultSrid) {
				geometry = projectService.transform(geometry, defaultSrid);
			}
			pathGeom = GeometryUtil.toJstsGeometry(geometry);
		} catch(e) {
			throw(new Error('参数错误！'));
		}
		var pathPoints = pathGeom.points;
		var arrival = pathGeom.getLength() < distance;
		var point;
		if(!arrival) {
			point = findPathPoint(pathPoints, distance, pathSrid);
			var pointGeom = new g2.sfs.Point({
				x: point[0],
				y: point[1],
				spatialReference: defaultSrid
			});
			if(pathSrid != defaultSrid) {
				pointGeom = projectService.transform(pointGeom, pathSrid);
				point[0] = pointGeom.x;
				point[1] = pointGeom.y;
				point[2] = point[2];
			}
		} else {

		}
		return {
			point: point,
			//是否到达终点
			arrival: arrival
		};
	}

	return util;
});
